// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { setupAxiosInterceptors } from "../utils/axiosInstance";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [role, setRole] = useState(null);
  const [userDetail, setUserDetail] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      setIsAuthenticated(true);
      storeUserData(token);
    } else {
      setIsAuthenticated(false);
    }
    setLoading(false);

    setupAxiosInterceptors(logout);

  }, []);

  const login = (token) => {
    localStorage.setItem("authToken", token);
    setIsAuthenticated(true);
    storeUserData(token);
    navigate("/admin/dashboard");
  };

  const logout = () => {
    localStorage.removeItem("authToken");
    setIsAuthenticated(false);
    setRole(null);
    navigate("/login");
  };

  const storeUserData = (token) => {
    try {
      const decodedToken = jwtDecode(token);
      setRole(decodedToken.role);
      setUserDetail(decodedToken);
    } catch (error) {
      console.error("Invalid token", error);
      setIsAuthenticated(false);
    }
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, loading, login, logout, role, userDetail }}>
      {children}
    </AuthContext.Provider>
  );
};
